(function () {
  'use strict';

  /* =========================================================
     CONFIG
  ========================================================= */

  const B2B_TRANSLATIONS = {
    fr: {
      headerButton: 'ACCÈS REVENDEUR B2B',
      locatorButton: 'TROUVER UN REVENDEUR',
      sidebarButton: 'ACCÈS REVENDEUR',
      loginTitle: 'CONNEXION ACCÈS PROFESSIONNEL',
      loginDesc: 'Entrez votre email et mot de passe pour vous connecter :',
      submit: 'SE CONNECTER',
      noAccount: 'Pas encore de compte professionnel ?',
      signup: "S'inscrire",
      signupNote: '(sous réservation de validation par nos équipes.)',
      recoverTitle: 'Récupération du mot de passe professionnel',
      recoverDesc: 'Entrez votre email professionnel pour récupérer votre mot de passe :'
    },

    en: {
      headerButton: 'B2B DEALER ACCESS',
      locatorButton: 'FIND A DEALER',
      sidebarButton: 'DEALER ACCESS',
      loginTitle: 'PROFESSIONAL ACCESS LOGIN',
      loginDesc: 'Enter your email and password to sign in:',
      submit: 'SIGN IN',
      noAccount: "Don't have a professional account yet?",
      signup: 'Register',
      signupNote: '(subject to validation by our team.)',
      recoverTitle: 'Professional password recovery',
      recoverDesc: 'Enter your professional email to recover your password:'
    },

    es: {
      headerButton: 'ACCESO REVENDEDOR B2B',
      locatorButton: 'BUSCAR UN DISTRIBUIDOR',
      sidebarButton: 'ACCESO REVENDEDOR',
      loginTitle: 'ACCESO PROFESIONAL',
      loginDesc: 'Introduce tu correo electrónico y contraseña para iniciar sesión:',
      submit: 'INICIAR SESIÓN',
      noAccount: '¿Aún no tienes una cuenta profesional?',
      signup: 'Registrarse',
      signupNote: '(sujeto a validación por nuestro equipo.)',
      recoverTitle: 'Recuperación de contraseña profesional',
      recoverDesc: 'Introduce tu correo profesional para recuperar tu contraseña:'
    },

    de: {
      headerButton: 'B2B-HÄNDLERZUGANG',
      locatorButton: 'HÄNDLER FINDEN',
      sidebarButton: 'HÄNDLERZUGANG',
      loginTitle: 'ANMELDUNG FÜR GEWERBEKUNDEN',
      loginDesc: 'Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um sich anzumelden:',
      submit: 'ANMELDEN',
      noAccount: 'Noch kein Geschäftskonto?',
      signup: 'Registrieren',
      signupNote: '(vorbehaltlich der Freigabe durch unser Team.)',
      recoverTitle: 'Wiederherstellung des Geschäftspassworts',
      recoverDesc: 'Geben Sie Ihre geschäftliche E-Mail-Adresse ein, um Ihr Passwort wiederherzustellen:'
    },

    it: {
      headerButton: 'ACCESSO RIVENDITORE B2B',
      locatorButton: 'TROVA UN RIVENDITORE',
      sidebarButton: 'ACCESSO RIVENDITORE',
      loginTitle: 'ACCESSO PROFESSIONALE',
      loginDesc: 'Inserisci email e password per accedere:',
      submit: 'ACCEDI',
      noAccount: 'Non hai ancora un account professionale?',
      signup: 'Registrati',
      signupNote: '(soggetto ad approvazione da parte del nostro team.)',
      recoverTitle: 'Recupero password professionale',
      recoverDesc: 'Inserisci la tua email professionale per recuperare la password:'
    },

    nl: {
      headerButton: 'B2B DEALERTOEGANG',
      locatorButton: 'VIND EEN DEALER',
      sidebarButton: 'DEALERTOEGANG',
      loginTitle: 'PROFESSIONELE TOEGANG',
      loginDesc: 'Voer je e-mailadres en wachtwoord in om in te loggen:',
      submit: 'INLOGGEN',
      noAccount: 'Nog geen professioneel account?',
      signup: 'Registreren',
      signupNote: '(onder voorbehoud van goedkeuring door ons team.)',
      recoverTitle: 'Herstel professioneel wachtwoord',
      recoverDesc: 'Voer je professionele e-mailadres in om je wachtwoord te herstellen:'
    }
  };

  const HOME_LANGS = ['fr', 'en', 'es', 'de', 'it', 'nl'];

  const SELECTORS = {
    header: '.header',
    headerElement: 'x-header.header',
    headerSidebarFooter: '.header-sidebar__footer',
    loginHeading: '#login .h3',
    loginDescription: '#login p',
    loginSubmit: '#customer_login button[type="submit"]',
    registerLink: '#customer_login a[href*="/account/register"]',
    recoverHeading: '#recover .h3',
    recoverDescription: '#recover p'
  };


  /* =========================================================
     HELPERS
  ========================================================= */

  function getCurrentLang() {
    const htmlLang = document.documentElement.getAttribute('lang');
    const shopifyLocale = window.Shopify && Shopify.locale;

    return (
      htmlLang ||
      shopifyLocale ||
      'fr'
    )
      .toLowerCase()
      .split('-')[0];
  }


  function tr() {
    const lang = getCurrentLang();

    return (
      B2B_TRANSLATIONS[lang] ||
      B2B_TRANSLATIONS.fr
    );
  }


  function safeRemove(el) {
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }


  function getOriginSafe() {
    return (
      window.location.origin ||
      'https://mocybell.com'
    );
  }


  function getShopifyRoot() {
    const root =
      (
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
      )
        ? Shopify.routes.root
        : '/';

    return root.endsWith('/')
      ? root.slice(0, -1)
      : root;
  }


  function getLocalizedPath(path) {
    const cleanPath =
      path.startsWith('/')
        ? path
        : `/${path}`;

    const root = getShopifyRoot();

    return (
      `${root}${cleanPath}` ||
      cleanPath
    );
  }


  function buildLocalizedUrl(path, hash) {
    const url =
      new URL(
        getLocalizedPath(path),
        getOriginSafe()
      );

    if (hash) {
      url.hash =
        hash.replace(/^#/, '');
    }

    return url;
  }


  function getMassyRegistrationPath() {
    return getLocalizedPath(
      '/apps/massy/pages/registration-form/b2b'
    );
  }


  function isHomepage() {
    const path =
      window.location.pathname
        .replace(/\/+$/, '') ||
      '/';

    if (path === '/') {
      return true;
    }

    return HOME_LANGS.some(
      (lang) =>
        path === `/${lang}`
    );
  }


  /* =========================================================
     STYLES
  ========================================================= */

  function injectStyles() {
    if (
      document.getElementById(
        'b2b-custom-styles'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'b2b-custom-styles';

    style.textContent = `

      /* ===========================
         DESKTOP HEADER
         =========================== */

      .b2b-button-container {
        position: absolute;
        top: 35%;
        left: 8%;
        z-index: 20;

        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }


      .b2b-access-btn {
        border: none;

        padding:
          8px
          16px;

        font-size: 12px;
        font-weight: bold;

        text-transform: uppercase;

        border-radius: 4px;

        cursor: pointer;

        background: transparent;

        transition:
          all
          0.3s
          ease;

        color: white;

        pointer-events: auto;
      }


      .store-locator-access-btn {
        display: inline-flex;
        align-items: center;
        gap: 4px;

        border: none;

        padding:
          0
          16px
          8px;

        font-size: 11px;
        font-weight: bold;

        line-height: 1.2;

        text-transform: uppercase;

        border-radius: 4px;

        cursor: pointer;

        background: transparent;

        color: white;

        text-decoration: none;

        white-space: nowrap;

        pointer-events: auto;

        transition:
          color 0.3s ease,
          opacity 0.3s ease,
          transform 0.3s ease;
      }


      .store-locator-access-btn::after {
        content: ' →';
        margin-left: 2px;
      }


      .imageaccessb2b {
        transition:
          filter
          0.3s
          ease;

        filter:
          brightness(0)
          invert(1);
      }


      .b2b-access-btn:hover,
      .store-locator-access-btn:hover {
        transform:
          translateY(-1px);
      }


      .store-locator-access-btn:hover {
        opacity: 0.8;
      }


      .b2b-access-btn:active,
      .store-locator-access-btn:active {
        transform:
          translateY(0);
      }


      /* ===========================
         MOBILE SIDEBAR
         =========================== */

      .acces-pro-link:hover,
      .mobile-store-locator-link:hover {
        opacity: 0.8;
      }


      @media (max-width: 768px) {

        .b2b-button-container {
          display: none;
        }

      }


      /* ===========================
         REGISTER
         =========================== */

      .b2b-register-button {
        display: inline-block;

        margin-top: 8px;

        padding:
          10px
          16px;

        background: #000;

        color: #fff !important;

        font-weight: 700;

        border-radius: 4px;

        text-decoration: none;

        transition:
          all
          0.2s
          ease;
      }


      .b2b-register-button:hover {
        background: #333;

        transform:
          translateY(-1px);
      }

    `;

    document.head.appendChild(
      style
    );
  }


  /* =========================================================
     1) FIX B2B PRICE DISPLAY
  ========================================================= */

  function fixB2bPriceDisplay() {

    document
      .querySelectorAll(
        'sale-price:not(.b2b-price-is-fixed)'
      )
      .forEach(
        (salePriceWrapper) => {

          const originalPriceElement =
            salePriceWrapper.querySelector(
              'del.ymq-b2b-cp-compare-price'
            );


          if (
            !originalPriceElement ||
            !originalPriceElement
              .classList
              .contains(
                'ymq-b2b-vat-hidden'
              )
          ) {
            return;
          }


          const unwantedHiddenPrice =
            salePriceWrapper.querySelector(
              'span.ymq-b2b-vat-hidden'
            );


          const finalHtPrice =
            salePriceWrapper.querySelector(
              'span.ymq-b2b-vat-price'
            );


          if (
            unwantedHiddenPrice
          ) {
            unwantedHiddenPrice.remove();
          }


          originalPriceElement
            .classList
            .remove(
              'ymq-b2b-vat-hidden'
            );


          originalPriceElement
            .style
            .display =
            'inline-block';


          if (
            finalHtPrice
          ) {

            salePriceWrapper.innerHTML =
              '';


            salePriceWrapper
              .appendChild(
                originalPriceElement
              );


            salePriceWrapper
              .appendChild(
                finalHtPrice
              );

          }


          salePriceWrapper
            .classList
            .add(
              'b2b-price-is-fixed'
            );

        }
      );

  }


  /* =========================================================
     2) HEADER DESKTOP
  ========================================================= */

  function injectHeaderButton() {

    if (
      document.querySelector(
        '.b2b-button-container'
      )
    ) {
      return;
    }


    const header =
      document.querySelector(
        SELECTORS.header
      );


    if (!header) {
      return;
    }


    const text = tr();


    const buttonContainer =
      document.createElement(
        'div'
      );


    buttonContainer.className =
      'b2b-button-container';


    /* ---------------------------
       BOUTON B2B
       --------------------------- */

    const button =
      document.createElement(
        'button'
      );


    button.className =
      'b2b-access-btn';


    button.type =
      'button';


    button.innerHTML = `
      ${text.headerButton}

      <img
        class="imageaccessb2b"
        style="
          max-width:18px;
          height:auto;
          display:inline-block;
        "
        src="https://cdn.shopify.com/s/files/1/0588/6895/7382/t/10/assets/login.svg?v=1751197173"
        alt="Login"
      >
    `;


    button.addEventListener(
      'click',
      function () {

        window.location.href =
          buildLocalizedUrl(
            '/account/login',
            'revendeur'
          )
          .toString();

      }
    );


    /* ---------------------------
       STORE LOCATOR DESKTOP
       --------------------------- */

    const locatorLink =
      document.createElement(
        'a'
      );


    locatorLink.className =
      'store-locator-access-btn';


    locatorLink.href =
      getLocalizedPath(
        '/pages/trouvez-votre-revendeur-mocybell'
      );


    locatorLink.textContent =
      text.locatorButton;


    locatorLink.setAttribute(
      'aria-label',
      text.locatorButton
    );


    /* ---------------------------
       INSERTION HEADER
       --------------------------- */

    buttonContainer
      .appendChild(
        button
      );


    buttonContainer
      .appendChild(
        locatorLink
      );


    header.insertBefore(
      buttonContainer,
      header.firstChild
    );

  }


  /* =========================================================
     HEADER COLORS
  ========================================================= */

  function updateHeaderButtonColors() {

    const headerElement =
      document.querySelector(
        SELECTORS.headerElement
      );


    const button =
      document.querySelector(
        '.b2b-access-btn'
      );


    const locatorLink =
      document.querySelector(
        '.store-locator-access-btn'
      );


    const icon =
      document.querySelector(
        '.b2b-access-btn .imageaccessb2b'
      );


    if (
      !headerElement ||
      !button ||
      !icon
    ) {
      return;
    }


    /* Pages internes */

    if (!isHomepage()) {

      button.style.color =
        'black';


      if (locatorLink) {

        locatorLink.style.color =
          'black';

      }


      icon.style.filter =
        'none';


      return;

    }


    /* Homepage */

    const hasYellowBackground =

      headerElement
        .classList
        .contains(
          'is-filled'
        )

      ||

      headerElement
        .classList
        .contains(
          'is-solid'
        )

      ||

      headerElement
        .matches(
          ':hover'
        );


    if (
      hasYellowBackground
    ) {

      button.style.color =
        'black';


      if (
        locatorLink
      ) {

        locatorLink.style.color =
          'black';

      }


      icon.style.filter =
        'none';

    }

    else {

      button.style.color =
        'white';


      if (
        locatorLink
      ) {

        locatorLink.style.color =
          'white';

      }


      icon.style.filter =
        'brightness(0) invert(1)';

    }

  }


  /* =========================================================
     3) LOGIN PAGE B2B
  ========================================================= */

  function modifyLoginForB2B() {

    if (
      !window.location.hash
        .includes(
          'revendeur'
        )
    ) {
      return;
    }


    const text = tr();


    const mainHeading =
      document.querySelector(
        SELECTORS.loginHeading
      );


    if (
      mainHeading
    ) {

      mainHeading.textContent =
        text.loginTitle;

    }


    const description =
      document.querySelector(
        SELECTORS.loginDescription
      );


    if (
      description
    ) {

      description.textContent =
        text.loginDesc;

    }


    const submitButton =
      document.querySelector(
        SELECTORS.loginSubmit
      );


    if (
      submitButton
    ) {

      submitButton.textContent =
        text.submit;

    }


    const registerLink =
      document.querySelector(
        SELECTORS.registerLink
      );


    if (
      registerLink &&
      registerLink.parentElement
    ) {

      const parent =
        registerLink.parentElement;


      if (
        !parent.dataset.b2bModified

        ||

        parent
          .dataset
          .b2bModifiedLang
        !==
        getCurrentLang()
      ) {

        parent.innerHTML = `

          <span class="text-subdued">
            ${text.noAccount}
          </span>

          <br>

          <a
            href="${getMassyRegistrationPath()}"
            class="b2b-register-button"
          >
            ${text.signup}
            ${text.signupNote}
          </a>

        `;


        parent.dataset.b2bModified =
          'true';


        parent.dataset.b2bModifiedLang =
          getCurrentLang();

      }

    }


    const recoverHeading =
      document.querySelector(
        SELECTORS.recoverHeading
      );


    if (
      recoverHeading
    ) {

      recoverHeading.textContent =
        text.recoverTitle;

    }


    const recoverDescription =
      document.querySelector(
        SELECTORS.recoverDescription
      );


    if (
      recoverDescription
    ) {

      recoverDescription.textContent =
        text.recoverDesc;

    }

  }


  function scheduleModifyLoginForB2B() {

    setTimeout(
      modifyLoginForB2B,
      150
    );

  }


  /* =========================================================
     4) MOBILE SIDEBAR
  ========================================================= */

  function addAccessProToSidebar() {

    const footer =
      document.querySelector(
        '.header-sidebar__footer'
      );


    if (!footer) {
      return;
    }


    const accountLink =
      footer.querySelector(
        'a[href*="/account"]'
      );


    if (!accountLink) {
      return;
    }


    const href =
      accountLink
        .getAttribute(
          'href'
        )
      ||
      '';


    const isLoginLink =
      href.includes(
        '/account/login'
      );


    /* ---------------------------
       Nettoyage anciens liens
       --------------------------- */

    const existingAccessPro =
      footer.querySelector(
        '.acces-pro-link'
      );


    if (
      existingAccessPro
    ) {

      safeRemove(
        existingAccessPro
      );

    }


    const existingLocator =
      footer.querySelector(
        '.mobile-store-locator-link'
      );


    if (
      existingLocator
    ) {

      safeRemove(
        existingLocator
      );

    }


    if (
      !isLoginLink
    ) {
      return;
    }


    const text = tr();


    /* ---------------------------
       ACCÈS REVENDEUR MOBILE
       --------------------------- */

    const targetUrl =
      buildLocalizedUrl(
        '/account/login',
        'revendeur'
      )
      .toString();


    const accessLink =
      document.createElement(
        'a'
      );


    accessLink.className =
      'acces-pro-link text-with-icon smallcaps';


    accessLink.href =
      targetUrl;


    accessLink.target =
      '_self';


    accessLink.setAttribute(
      'role',
      'link'
    );


    accessLink.setAttribute(
      'aria-label',
      text.sidebarButton
    );


    accessLink.style.cssText = `

      margin-left: 12px;

      display: inline-flex;

      align-items: center;

      gap: 6px;

      font-size: 10px;

      text-transform: uppercase;

      font-weight: 500;

      color: black;

      text-decoration: none;

      white-space: nowrap;

      transition:
        opacity
        0.3s
        ease;

      cursor: pointer;

      position: relative;

      z-index: 5;

    `;


    accessLink.innerHTML = `

      <img
        style="
          width:18px;
          height:auto;
          display:inline-block;
          filter:none;
          pointer-events:none;
        "
        src="https://cdn.shopify.com/s/files/1/0588/6895/7382/t/10/assets/login.svg?v=1751197173"
        alt=""
      >

      <span
        style="
          pointer-events:none;
        "
      >
        ${text.sidebarButton}
      </span>

    `;


    accessLink.addEventListener(
      'click',
      function (e) {

        e.preventDefault();

        e.stopPropagation();


        const target =
          buildLocalizedUrl(
            '/account/login',
            'revendeur'
          );


        target
          .searchParams
          .set(
            '_t',
            Date.now()
          );


        window.location.assign(
          target.toString()
        );

      }
    );


    accessLink.addEventListener(
      'touchstart',
      function (e) {

        e.stopPropagation();

      },
      {
        passive: true
      }
    );


    accountLink
      .insertAdjacentElement(
        'afterend',
        accessLink
      );


    /* ---------------------------
       STORE LOCATOR MOBILE
       --------------------------- */

    const locatorMobileLink =
      document.createElement(
        'a'
      );


    locatorMobileLink.className =
      'mobile-store-locator-link text-with-icon smallcaps';


    locatorMobileLink.href =
      getLocalizedPath(
        '/pages/trouvez-votre-revendeur-mocybell'
      );


    locatorMobileLink.target =
      '_self';


    locatorMobileLink.setAttribute(
      'role',
      'link'
    );


    locatorMobileLink.setAttribute(
      'aria-label',
      text.locatorButton
    );


    locatorMobileLink.style.cssText = `

      margin-left: 12px;

      margin-top: 8px;

      display: inline-flex;

      align-items: center;

      gap: 6px;

      font-size: 10px;

      text-transform: uppercase;

      font-weight: 500;

      color: black;

      text-decoration: none;

      white-space: nowrap;

      transition:
        opacity
        0.3s
        ease;

      cursor: pointer;

      position: relative;

      z-index: 5;

    `;


    locatorMobileLink.innerHTML = `

      <span
        style="
          font-size:12px;
          line-height:1;
          pointer-events:none;
        "
      >
        📍
      </span>

      <span
        style="
          pointer-events:none;
        "
      >
        ${text.locatorButton} →
      </span>

    `;


    locatorMobileLink.addEventListener(
      'click',
      function (e) {

        e.stopPropagation();

      }
    );


    locatorMobileLink.addEventListener(
      'touchstart',
      function (e) {

        e.stopPropagation();

      },
      {
        passive: true
      }
    );


    accessLink
      .insertAdjacentElement(
        'afterend',
        locatorMobileLink
      );

  }


  /* =========================================================
     GLOBAL INIT
  ========================================================= */

  function runB2BEnhancements() {

    fixB2bPriceDisplay();

    injectHeaderButton();

    updateHeaderButtonColors();

    addAccessProToSidebar();

    modifyLoginForB2B();

  }


  function init() {

    injectStyles();


    runB2BEnhancements();


    setTimeout(
      runB2BEnhancements,
      300
    );


    setTimeout(
      runB2BEnhancements,
      800
    );


    setTimeout(
      runB2BEnhancements,
      1500
    );


    const headerElement =
      document.querySelector(
        SELECTORS.headerElement
      );


    if (
      headerElement

      &&

      !headerElement
        .dataset
        .b2bHoverAttached
    ) {

      headerElement
        .dataset
        .b2bHoverAttached =
        'true';


      headerElement
        .addEventListener(
          'mouseenter',
          updateHeaderButtonColors
        );


      headerElement
        .addEventListener(
          'mouseleave',
          updateHeaderButtonColors
        );


      const headerObserver =
        new MutationObserver(
          updateHeaderButtonColors
        );


      headerObserver.observe(
        headerElement,
        {
          attributes: true,

          attributeFilter:
            ['class']
        }
      );

    }


    window.addEventListener(
      'scroll',
      updateHeaderButtonColors
    );


    window.addEventListener(
      'hashchange',
      function () {

        scheduleModifyLoginForB2B();


        setTimeout(
          addAccessProToSidebar,
          200
        );

      }
    );


    window.addEventListener(
      'popstate',
      function () {

        scheduleModifyLoginForB2B();


        setTimeout(
          addAccessProToSidebar,
          200
        );

      }
    );


    document.addEventListener(
      'click',
      function (e) {

        if (

          e.target.closest(
            '[aria-controls*="header-sidebar"]'
          )

          ||

          e.target.closest(
            '.header__icon-list'
          )

          ||

          e.target.closest(
            '.header-sidebar__close-button'
          )

          ||

          e.target.closest(
            '.drawer__close-button'
          )

          ||

          e.target.closest(
            '.header-sidebar'
          )

        ) {

          setTimeout(
            addAccessProToSidebar,
            250
          );

        }

      }
    );


    scheduleModifyLoginForB2B();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  }

  else {

    init();

  }

})();